import React from 'react';
import '../styles/TeamMemberCard.css';

interface TeamMemberCardProps {
    name: string;
    surname: string;
    position: string;
    description: string;
    image: string;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ name, surname, position, description, image }) => {
    return (
        <div className="team-member-card" role="article">
            <img 
                src={image} 
                alt={`${name} ${surname} - ${position} en Terral Team`} 
                className="team-member-image"
            />
            <h3 className="team-member-name">{name}</h3>
            <h4 className="team-member-surname">{surname}</h4>
            <p className="team-member-position">{position}</p>
            <div className="team-member-expanded-content">
                <p className="team-member-description">{description}</p>
            </div>
        </div>
    );
};

export default TeamMemberCard; 